import moment from 'moment'
export const getCompetitorRowClassName = (competitor) => {

    var now = new moment().subtract(2, 'minutes')
    var lastMod = competitor && competitor.lastModified ? new moment( competitor.lastModified) : null
    if( now.isBefore(lastMod)){
        return "changed"
    }
    else {
        return ""
    }
}

const indexOf = ( list, currentId) => {
    let idx = list.findIndex( (e) => (e.id === currentId || e.sequence === currentId))
    return idx
}

const prevIndexOf = ( list, currentId) => {
    let idx = indexOf( list, currentId)
    if( idx === -1 ){
        idx = 0
    }
    else if( idx === 0){
        idx = list.length - 1
    }
    else {
        idx = idx -1 
    }
    return idx
}
const nextIndexOf = ( list, currentId) => {
    let idx = indexOf( list, currentId)
    if( idx === -1 ){
        idx = 0
    }
    else if( idx === list.length - 1){
        idx = 0
    }
    else {
        idx = idx +1 
    }
    return idx
}

export const nextIdInSelectorList = (list, type, currentId) => {
    let idx = nextIndexOf( list, currentId ? currentId : 0)
    if( type === 'checkPoint'){
        return list[idx].sequence
    }
    else {
        return list[idx].id
    }
    
}

export const prevIdInSelectorList = (list, type, currentId) => {
    let idx = prevIndexOf( list, currentId ? currentId : 0)
    if( type === 'checkPoint'){
        return list[idx].sequence
    }
    else {
        return list[idx].id
    }
    
}